import React from 'react';
import { useViewOnly } from '../../contexts';
import './ProductionBanner.css';

const ProductionBanner = ({ language = 'he' }) => {
  const { isProduction } = useViewOnly();
  if (!isProduction) return null;

  const text = language === 'he'
    ? '⚠️ סביבת ייצור — נתוני מרפאה אמיתיים'
    : '⚠️ PRODUCTION — Real clinic data';

  return (
    <div className="production-banner" dir={language === 'he' ? 'rtl' : 'ltr'} role="status">
      <span>{text}</span>
    </div>
  );
};

export default ProductionBanner;
